import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  AssessmentCard,
  ControlledSelectField,
  ControlledTextField,
} from '../../shared';
import { rules } from '../../demographics/rules';
import { PrimaryPolicyHolderFormValues } from '../primary-policyholder';
import { selectIsGuardian } from '../../../../redux/session';
import {
  AdultPolicyholderOptions,
  minorPolicyholderOptions,
} from '../../../../helpers/assessment';
import { selectPatientGuardians } from '../../../../redux/assessment';

type FormValues = {
  insuranceId: string;
};

const MoreInsuranceInfoForm = ({ form }) => {
  const { control } = form;

  const isGuardian = useSelector(selectIsGuardian);
  const patientGuardians = useSelector(selectPatientGuardians);
  const secondaryGuardian = patientGuardians?.secondary;

  return (
    <AssessmentCard>
      <Typography component="h3" variant="h5">
        We need just a little more info
      </Typography>
      <ControlledTextField<FormValues>
        name="insuranceId"
        control={control}
        rules={rules.insuranceId}
        label="Member ID"
        inputProps={{ maxLength: 50 }}
        defaultValue=""
        sx={{ mt: 2 }}
      />
      <ControlledSelectField<PrimaryPolicyHolderFormValues>
        control={control}
        name="relationToPatient"
        defaultValue=""
        label="Who is the policyholder?"
        options={
          isGuardian
            ? minorPolicyholderOptions(!!secondaryGuardian)
            : AdultPolicyholderOptions
        }
        rules={rules.policyholder}
        sx={{ mt: 2 }}
      />
    </AssessmentCard>
  );
};

export default MoreInsuranceInfoForm;
